var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContentCodes = function SvgContentCodes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.474 15.737v1.895A2.37 2.37 0 0 0 13.842 20h5.684a.473.473 0 0 0 .474-.474v-3.79a2.37 2.37 0 0 0-2.368-2.368h-3.79a2.37 2.37 0 0 0-2.368 2.369zm1.42.19c.001-.628.546-1.137 1.219-1.138h3.248c.672.001 1.217.51 1.218 1.137v2.653h-4.466c-.673 0-1.218-.51-1.218-1.137v-1.516zM20 2.473A.473.473 0 0 0 19.526 2h-3.79a2.37 2.37 0 0 0-2.368 2.368v1.895a2.37 2.37 0 0 0 2.369 2.369h1.895A2.37 2.37 0 0 0 20 6.263v-3.79zm-1.421 3.6c0 .627-.51 1.136-1.137 1.137h-1.516c-.626 0-1.136-.51-1.136-1.136V4.558a1.139 1.139 0 0 1 1.137-1.137h2.653v2.653zM8.158 2h-3.79A2.37 2.37 0 0 0 2 4.368v4.264h6.157a2.37 2.37 0 0 0 2.37-2.369V4.368A2.37 2.37 0 0 0 8.156 2zm.947 4.074c0 .627-.545 1.136-1.218 1.137H3.421V4.558c0-.628.546-1.136 1.218-1.137h3.248c.673 0 1.218.51 1.218 1.137v1.516zM2 17.632h4.263v1.894H2v-1.894zm6.158 0h1.895v1.894H8.158v-1.894zm-1.895-3.79h1.895v1.895H6.263v-1.895zm1.895-3.79v1.895H6.263v-1.894h1.895zm0 1.895h1.895v1.895H8.158v-1.895zm5.684-1.894h1.895v1.894h-1.895v-1.894zm-3.79 0h1.895v1.894h-1.894v-1.894zm7.58 0h1.894v1.894h-1.894v-1.894zM2 13.843h2.368v1.894H2v-1.895z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgContentCodes;